import { useEffect } from 'react';

export const useGlobalEventListener = (type, listener, addTo = document) => {
  useEffect(() => {
    addTo.addEventListener(type, listener);

    return () => addTo.removeEventListener(type, listener);
  });
};
